import { render, staticRenderFns } from "./OperaOrderRefundWindow.vue?vue&type=template&id=6c5ffbf4&scoped=true&"
import script from "./OperaOrderRefundWindow.vue?vue&type=script&lang=js&"
export * from "./OperaOrderRefundWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaOrderRefundWindow.vue?vue&type=style&index=0&id=6c5ffbf4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5ffbf4",
  null
  
)

export default component.exports